"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _webgltextureLoader = require("webgltexture-loader");

var VideoTextureLoader = /*#__PURE__*/function (_webgltextureLoader$W) {
  _inherits(VideoTextureLoader, _webgltextureLoader$W);

  var _super = _createSuper(VideoTextureLoader);

  function VideoTextureLoader() {
    _classCallCheck(this, VideoTextureLoader);

    return _super.apply(this, arguments);
  }

  _createClass(VideoTextureLoader, [{
    key: "canLoad",
    value: function canLoad(input) {
      return input instanceof HTMLVideoElement;
    }
  }, {
    key: "inputHash",
    value: function inputHash(input) {
      return input;
    }
  }, {
    key: "loadNoCache",
    value: function loadNoCache(input) {
      var gl = this.gl;
      var width = input.width,
          height = input.height;
      var timeout;

      var dispose = function dispose() {
        clearTimeout(timeout);
      };

      var promise = new Promise(function (resolve, reject) {
        var checkVideoReady = function checkVideoReady() {
          if (input.videoWidth > 0) {
            var texture = gl.createTexture();
            var _width = input.videoWidth,
                _height = input.videoHeight;
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, input);
            resolve({
              texture: texture,
              width: _width,
              height: _height
            });
          } else {
            timeout = setTimeout(checkVideoReady, 100);
          }
        };

        checkVideoReady();
      });
      return {
        dispose: dispose,
        promise: promise
      };
    }
  }, {
    key: "update",
    value: function update(input) {
      var gl = this.gl;
      var res = this.get(input);
      if (!res) return;
      gl.bindTexture(gl.TEXTURE_2D, res.texture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, input);
    }
  }]);

  return VideoTextureLoader;
}(_webgltextureLoader.WebGLTextureLoaderAsyncHashCache);

_webgltextureLoader.globalRegistry.add(VideoTextureLoader);

var _default = VideoTextureLoader;
exports.default = _default;